import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Link,
  makeStyles,
} from "@material-ui/core";
import { fieldLabels } from "../../../item/fieldLabels";
import { ActivityBody, ActivityDialogProps } from "../types";
import { UpdatedValue } from "@ofqual/portal-activity-feed/activityfeed/UpdatedValue";
import ReactMarkdown from "react-markdown";
import { AoRoles, rolesLookup } from "../../../../domain/userRole";

const useStyles = makeStyles((theme) => ({
  changeDetails: {
    padding: 15,
  },
  actions: {
    padding: 15,
  },
}));

export const UpdatedDialog: React.FC<ActivityDialogProps> = ({
  activity,
  onClose,
}) => {
  const classes = useStyles();

  const body: ActivityBody = JSON.parse(activity.activityMetaData);

  // special case here roles is a list of numbers with a mapping only know this side so..
  const rolesLookups = rolesLookup(AoRoles);
  body.changes.map((change) => {
    if (change.field === "roles" && change.oldValue) {
      const oldVal = Array.from(change.oldValue).map((x) => {
        let val = rolesLookups.find((y) => Number(x) === y.id);
        return val?.label;
      });
      change.oldValue = oldVal.toString();
    }

    if (change.field === "roles" && change.newValue) {
      const newVal = Array.from(change.newValue).map((x) => {
        let val = rolesLookups.find((y) => Number(x) === y.id);
        return val?.label;
      });
      change.newValue = newVal.toString();
    }

    if (change.field === "orgs" && change.oldValue && typeof change.oldValue !== "string") {
      change.oldValue = change.oldValue.map(x => ({ "Organisation name": x.name }));
    }

    if (change.field === "orgs" && change.newValue && typeof change.newValue !== "string") {
      change.newValue = change.newValue.map(x => ({ "Organisation name": x.name }));
    }

    return change;
  });

  const renderChange = (c: Array<any> | string) => {
    if (typeof c === "string") {
      return c;
    } else {
      return c.join(", ");
    }
  }

  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-test="updated-dialog"
    >
      <DialogTitle data-test="activity-title">
        {activity.activityTitle}
      </DialogTitle>
      <Divider />
      <DialogContent>
        {body.changes.map((change) => (
          <div key={change.field}>
            <h4 data-test="activity-field-title">
              {fieldLabels[change.field] || "Unknown Field"}
            </h4>
            <div className={classes.changeDetails}>
              <b>Old value: </b>
              {change.field === "message" ? (
                <ReactMarkdown>{renderChange(change.oldValue || "")}</ReactMarkdown>
              ) : (
                <UpdatedValue
                  value={change.oldValue}
                  fieldLabels={fieldLabels}
                />
              )}
              <br />
              <b>New value: </b>
              {change.field === "message" ? (
                <ReactMarkdown>{renderChange(change.newValue || "")}</ReactMarkdown>
              ) : (
                <UpdatedValue
                  value={change.newValue}
                  fieldLabels={fieldLabels}
                />
              )}
            </div>
          </div>
        ))}
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Link
          component="button"
          onClick={onClose}
          data-test="close-change-button"
        >
          Close
        </Link>
      </DialogActions>
    </Dialog>
  );
};
